import FeladatCsoportDto from 'app/admin/feladatCsoport/dto/FeladatCsoportDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';

class FeladatCsoportTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'feladatCsoportTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, FeladatCsoportDto)))
				.catch(reject);
		});
	}
}

export default new FeladatCsoportTableService();
